<template>
  <v-app>
    <v-app-bar app color="dark" dark>
      <v-toolbar-title>Layout Labelling</v-toolbar-title>
    </v-app-bar>
    <v-main>
      <v-container fill-height>
        <v-row align="center" justify="center">
          <v-col cols="12" md="8">
            <v-card class="pa-8 text-center" v-if="loaded">
              <template v-if="passed">
                <v-icon size="72" color="success">mdi-check-circle</v-icon>
                <h2 class="text-h4 mt-4 mb-4">Nice work!</h2>
                <p class="text-h6 mb-4">You passed the screening check.</p>
                <p class="mb-6 text-body-1">
                  You are ready for the main study. Take your time and answer carefully.
                </p>
                <v-btn color="primary" large @click="goToMain">
                  Continue
                </v-btn>
              </template>

              <template v-else>
                <h2 class="text-h4 mb-4">Thanks for your time</h2>
                <p class="text-body-1 mb-4">
                  This study requires quickly and accurately judging paths in network drawings,
                  and your answers on the practice and check questions tell us the main task is
                  not a good fit for you today. This is not a reflection of your effort, and it
                  does not affect your Prolific standing.
                </p>
                <p class="text-body-1 mb-6">
                  You will be compensated for the time you spent on the training, in line with
                  the study description. Please use the button below to return to Prolific.
                </p>
                <v-btn color="primary" large :href="completionUrl">
                  Return to Prolific
                </v-btn>
              </template>
            </v-card>
            <div v-else class="text-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import config from '@/config';
import prolificConfig from '@/config/prolific';

export default {
  name: 'TrainingResult',
  title: 'Training Result',
  data() {
    return {
      sessionId: this.$route.params.sessionId,
      loaded: false,
      passed: false,
      completionUrl: prolificConfig.PROLIFIC_COMPLETION_URL,
    };
  },
  async created() {
    try {
      const sessionResp = await fetch(`${config.API_BASE_URL}/prolific/session/${this.sessionId}/`);
      const session = await sessionResp.json();
      this.passed = Boolean(session.training_passed) && session.phase === 'main';
      if (session.prolific_completion_url) {
        this.completionUrl = session.prolific_completion_url;
      }
      this.loaded = true;
      // Passed users should go straight to main; this page is mainly for screen-outs
      if (this.passed) {
        this.$router.replace(`/prolific/study/${this.sessionId}/main`);
      }
    } catch (e) {
      console.error(e);
      this.loaded = true;
      this.passed = false;
    }
  },
  methods: {
    goToMain() {
      this.$router.push(`/prolific/study/${this.sessionId}/main-intro`);
    },
  },
};
</script>
